export const GENERAL = {
  GMAP_API_KEY: "AIzaSyDv-NdCjT75Fnb96OlGFBvZbKnYb0oNr08",
  GMAP_MAP_ID: "53f50046625539f6",
};
